import { HttpParams } from '@angular/common/http'
import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, MaterialTransfer, ModalSize, VpUser } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { MaterialTransferRecordComponent } from './material-transfer-record.component'

@Component({
    templateUrl: './material-transfer-records.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class MaterialTransferRecordsComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch
    grid: Grid<MaterialTransfer>
    allEquipment: any[] = []
    allJobs: any[] = []
    materialMap!: DataMap
    locationMap!: DataMap
    activeUsers: VpUser[] = []
    allUserMap!: DataMap

    constructor() {
        super()

        this.grid = new Grid<MaterialTransfer>(this.services)
            .setupModalEditing(
                this.services.data.materialTransfers,
                'Transfer Record',
                MaterialTransferRecordComponent,
                () => new MaterialTransfer(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.material, item.location, item.userName, item.requestedByName])

        this.refresh()
    }
    refresh() {
        const params = new HttpParams().set('withJobs', true)
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.materialTransfers.queryAll(),
                    this.services.data.get('api/VpMaterial/GetToolsMaterials'),
                    this.services.data.get('/api/VpMaterial/GetMaterialLocations', params),
                    this.services.data.get('/api/VpMaterial/GetSmallToolLocations'),
                    this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', false)), // Get all for lookup of any employee
                    this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', true)), // Get active for assigning current employees
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.grid.items = result[0]
                        this.allEquipment = result[1]
                        this.materialMap = new DataMap(result[1], 'barcode', 'name')

                        // Let's build a list for a map of locations for both materials and tools with no duplicates
                        const allLocations = [...result[2], ...result[3]]
                        this.locationMap = new DataMap(allLocations, 'key', 'value')

                        // We don't actually use this map for the grid, so we can use the search field on userName.
                        this.allUserMap = new DataMap(result[4] as VpUser[], 'id', 'name')
                        this.activeUsers = result[5] as VpUser[] // We'll use the active users in the modal
                    },
                }),
        )
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.ToolRoomRecordsEdit])
    }
}
